// extracted by mini-css-extract-plugin
export default {"container":"OTP_container__GM7Q0","OTPInput":"OTP_OTPInput__szraz","receiveCode":"OTP_receiveCode__uj-60","resend":"OTP_resend__9pzDV","error":"OTP_error__0mwfM"};